module.exports = __webpack_public_path__ + "img/38.a63a878e.jpg";